/**
 * Whether persisted SOF photos can be deleted: only while editing (not the
 * read-only history view) and only until the SOF's receiving is Complete.
 * A completed SOF is a record of what was staged, so its photos are read-only.
 * The server enforces the same rule and returns 400 otherwise.
 *
 * @param readOnly - True on the history (read-only) route.
 * @param receivingStatus - The SOF's receiving status ('Pending' /
 *   'In Progress' / 'Complete', matched case-insensitively).
 * @returns True when delete affordances should be shown/allowed.
 */
export function canDeleteSofPhotos(
  readOnly: boolean,
  receivingStatus: string | null | undefined
): boolean {
  if (readOnly) {
    return false;
  }
  return (receivingStatus ?? '').trim().toLowerCase() !== 'complete';
}
